import createReducer from '../utils/createReducer';
import gqlEligibilityActions from '../actions/gqlEligibility';

const initialState = {};

const actionHandlers = {
    [gqlEligibilityActions.GET_GQL_ELIGIBLITY_SUCCESS](state, {payload}) {
        return {
            ...state,
            metadata: {...payload.eligibilityData}
        };
    },

    [gqlEligibilityActions.GET_GQL_ELIGIBLITY_ERROR](state, {payload}) {
        return {
            ...state,
            errorKey: payload.errorKey
        };
    }
};

export default createReducer(actionHandlers, initialState);